import React, { useState, useEffect, useRef } from 'react';
import '../styles/BlingImport.css';
import { detectarCategorias } from './CatalogForm';

function mapProduto(p) {
  const imgs = [];
  if (p.imagemURL) imgs.push(p.imagemURL);
  else if (p.imageThumbnailURL) imgs.push(p.imageThumbnailURL);
  else if (p.imagem) imgs.push(p.imagem);

  const dim = p.dimensoes || {};
  const pesoKg = parseFloat(dim.pesoBruto || dim.pesoLiquido) || 0;

  const descRaw = p.descricaoCurta || '';
  const titulo = p.nome || '';
  return {
    titulo,
    precoWeb: p.preco ? String(p.preco) : '0',
    meuPreco: p.preco ? String(p.preco) : '',
    altura:      dim.altura       ? String(dim.altura)       : '',
    largura:     dim.largura      ? String(dim.largura)      : '',
    comprimento: dim.profundidade ? String(dim.profundidade) : '',
    peso: pesoKg ? String(Math.round(pesoKg * 1000)) : '',
    descricao: descRaw.replace(/<[^>]*>/g, '').trim(),
    imagens: imgs,
    categorias: detectarCategorias(titulo),
    _blingId: p.id,
  };
}

const CAMPOS_LABELS = [
  { key: 'titulo',    label: 'Título' },
  { key: 'preco',     label: 'Preço' },
  { key: 'descricao', label: 'Descrição' },
  { key: 'dimensoes', label: 'Dimensões (A×L×C)' },
  { key: 'peso',      label: 'Peso' },
  { key: 'imagens',   label: 'Imagens' },
];

function BlingImport({ onClose, onImportar, onAtualizar }) {
  const [fase, setFase] = useState('verificando');
  const [erro, setErro] = useState('');
  const [produtos, setProdutos] = useState([]);
  const [selecionados, setSelecionados] = useState({});
  const [page, setPage] = useState(1);
  const [temMais, setTemMais] = useState(false);
  const [carregandoMais, setCarregandoMais] = useState(false);
  const [importado, setImportado] = useState(false);
  const [importando, setImportando] = useState(false);
  const [modo, setModo] = useState('importar'); // 'importar' | 'atualizar'
  const [camposAtualizar, setCamposAtualizar] = useState({
    titulo: false, preco: false, descricao: false,
    dimensoes: false, peso: false, imagens: false,
  });
  // Map String(_blingId) → localProduct.id
  const [blingMap, setBlingMap] = useState({});
  const pollRef = useRef(null);

  const workerUrl = (localStorage.getItem('workerUrl') || '').replace(/\/$/, '');
  const authToken = localStorage.getItem('authToken') || '';

  function headers() {
    return { 'X-Auth-Token': authToken };
  }

  // Build map of already-imported products from localStorage
  useEffect(() => {
    const existentes = JSON.parse(localStorage.getItem('products') || '[]');
    const map = {};
    existentes.forEach(p => { if (p._blingId) map[String(p._blingId)] = p.id; });
    setBlingMap(map);
  }, []);

  async function checkStatus() {
    const resp = await fetch(`${workerUrl}/bling/status`, { headers: headers() });
    const data = await resp.json();
    return data.connected;
  }

  async function carregarProdutos(pg = 1, acumular = false) {
    const resp = await fetch(`${workerUrl}/bling/produtos?page=${pg}`, { headers: headers() });
    if (!resp.ok) {
      if (resp.status === 401) { setFase('conectar'); return; }
      throw new Error(`Erro ${resp.status}`);
    }
    const json = await resp.json();
    if (json.erro || json.error) { setFase('conectar'); return; }
    const lista = (json.data || [])
      .filter(p => p.estoque && p.estoque.saldoVirtualTotal > 0)
      .map(mapProduto);
    if (acumular) {
      setProdutos(prev => [...prev, ...lista]);
    } else {
      setProdutos(lista);
    }
    setTemMais(lista.length === 100);
    setPage(pg);
  }

  useEffect(() => {
    if (!workerUrl || !authToken) {
      setErro('Configure o Worker URL e o Token em ⚙️ Configurações primeiro.');
      setFase('erro');
      return;
    }
    checkStatus()
      .then(async (connected) => {
        if (connected) {
          setFase('carregando');
          await carregarProdutos(1);
          setFase('lista');
        } else {
          setFase('conectar');
        }
      })
      .catch(e => { setErro(e.message); setFase('erro'); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const conectarBling = async () => {
    try {
      const resp = await fetch(`${workerUrl}/bling/auth-url`, { headers: headers() });
      const data = await resp.json();
      window.open(data.url, '_blank', 'width=600,height=700');
      pollRef.current = setInterval(async () => {
        const connected = await checkStatus();
        if (connected) {
          clearInterval(pollRef.current);
          setFase('carregando');
          await carregarProdutos(1);
          setFase('lista');
        }
      }, 2000);
    } catch (e) {
      setErro(e.message);
      setFase('erro');
    }
  };

  useEffect(() => {
    return () => { if (pollRef.current) clearInterval(pollRef.current); };
  }, []);

  const carregarMais = async () => {
    setCarregandoMais(true);
    try { await carregarProdutos(page + 1, true); }
    catch (e) { alert('Erro ao carregar mais: ' + e.message); }
    setCarregandoMais(false);
  };

  const toggleItem = (idx) => setSelecionados(prev => ({ ...prev, [idx]: !prev[idx] }));

  const toggleTodos = () => {
    const allSelected = produtosVisiveis.every(p => selecionados[produtos.indexOf(p)]);
    if (allSelected) {
      setSelecionados({});
    } else {
      const todos = {};
      produtosVisiveis.forEach(p => { todos[produtos.indexOf(p)] = true; });
      setSelecionados(todos);
    }
  };

  // Fetch detail from Bling
  async function fetchDetalhe(blingId) {
    const resp = await fetch(`${workerUrl}/bling/produto/${blingId}`, { headers: headers() });
    const json = await resp.json();
    return json.data || {};
  }

  const importar = async () => {
    setImportando(true);
    const escolhidos = produtos.filter((_, i) => selecionados[i]);

    const completos = await Promise.all(
      escolhidos.map(async (p) => {
        try {
          const det = await fetchDetalhe(p._blingId);
          const imgs = (det.imagens || [])
            .sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
            .map(img => img.link || img.linkMiniatura)
            .filter(Boolean);
          if (imgs.length === 0 && det.imagemURL) imgs.push(det.imagemURL);
          if (imgs.length === 0) imgs.push(...p.imagens);

          const dim = det.dimensoes || {};
          const pesoKg = parseFloat(dim.pesoBruto || dim.pesoLiquido) || 0;
          const descRaw = det.descricaoCurta || det.descricao || p.descricao || '';
          const descricao = descRaw.replace(/<[^>]*>/g, '').trim();

          return {
            ...p,                    // _blingId preserved
            imagens: imgs,
            descricao,
            altura:      dim.altura       ? String(dim.altura)       : p.altura,
            largura:     dim.largura      ? String(dim.largura)      : p.largura,
            comprimento: dim.profundidade ? String(dim.profundidade) : p.comprimento,
            peso: pesoKg ? String(Math.round(pesoKg * 1000)) : p.peso,
          };
        } catch {
          return { ...p };          // _blingId preserved in fallback
        }
      })
    );

    onImportar(completos);
    setImportado(true);
    setImportando(false);
    setTimeout(onClose, 1200);
  };

  const atualizar = async () => {
    const algumCampo = Object.values(camposAtualizar).some(Boolean);
    if (!algumCampo) { alert('Selecione pelo menos um campo para atualizar.'); return; }
    setImportando(true);

    const escolhidos = produtosVisiveis.filter(p => selecionados[produtos.indexOf(p)]);

    const atualizacoes = await Promise.all(
      escolhidos.map(async (p) => {
        const localId = blingMap[String(p._blingId)];
        if (!localId) return null;
        try {
          const det = await fetchDetalhe(p._blingId);
          const update = { id: localId };

          if (camposAtualizar.titulo    && det.nome)   update.titulo  = det.nome;
          if (camposAtualizar.preco     && det.preco)  update.meuPreco = String(det.preco);

          if (camposAtualizar.descricao) {
            const raw = det.descricaoCurta || det.descricao || '';
            update.descricao = raw.replace(/<[^>]*>/g, '').trim();
          }

          const dim = det.dimensoes || {};
          if (camposAtualizar.dimensoes) {
            if (dim.altura)       update.altura      = String(dim.altura);
            if (dim.largura)      update.largura     = String(dim.largura);
            if (dim.profundidade) update.comprimento = String(dim.profundidade);
          }

          if (camposAtualizar.peso) {
            const pesoKg = parseFloat(dim.pesoBruto || dim.pesoLiquido) || 0;
            if (pesoKg) update.peso = String(Math.round(pesoKg * 1000));
          }

          if (camposAtualizar.imagens) {
            const imgs = (det.imagens || [])
              .sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
              .map(img => img.link || img.linkMiniatura)
              .filter(Boolean);
            if (imgs.length) update.imagens = imgs;
          }

          return update;
        } catch { return null; }
      })
    );

    onAtualizar(atualizacoes.filter(Boolean));
    setImportado(true);
    setImportando(false);
    setTimeout(onClose, 1200);
  };

  // Products shown based on current mode
  const produtosVisiveis = modo === 'atualizar'
    ? produtos.filter(p => blingMap[String(p._blingId)])
    : produtos;

  const qtdSelecionados = produtosVisiveis.filter(p => selecionados[produtos.indexOf(p)]).length;
  const qtdJaImportados = produtos.filter(p => blingMap[String(p._blingId)]).length;

  return (
    <div className="bling-overlay" onClick={onClose}>
      <div className="bling-modal" onClick={e => e.stopPropagation()}>
        <div className="bling-header">
          <h2>{modo === 'atualizar' ? '🔄 Atualizar do Bling' : '📦 Importar do Bling'}</h2>
          <button className="bling-close" onClick={onClose}>✕</button>
        </div>

        {/* Abas importar / atualizar */}
        {fase === 'lista' && (
          <div className="bling-abas">
            <button
              className={`bling-aba${modo === 'importar' ? ' ativo' : ''}`}
              onClick={() => { setModo('importar'); setSelecionados({}); setImportado(false); }}
            >
              📥 Importar novos
            </button>
            <button
              className={`bling-aba${modo === 'atualizar' ? ' ativo' : ''}`}
              onClick={() => { setModo('atualizar'); setSelecionados({}); setImportado(false); }}
              disabled={qtdJaImportados === 0}
              title={qtdJaImportados === 0 ? 'Nenhum produto foi importado do Bling ainda' : ''}
            >
              🔄 Atualizar existentes{qtdJaImportados > 0 ? ` (${qtdJaImportados})` : ''}
            </button>
          </div>
        )}

        <div className="bling-body">

          {fase === 'verificando' && (
            <div className="bling-status">
              <div className="spin">⚙️</div>
              <p>Verificando conexão com Bling...</p>
            </div>
          )}

          {fase === 'conectar' && (
            <div className="bling-status">
              <div style={{ fontSize: 52, marginBottom: 16 }}>🔗</div>
              <p style={{ marginBottom: 20, color: '#444' }}>Autorize o acesso ao Bling para importar seus produtos.</p>
              <button className="btn-importar-bling" style={{ maxWidth: 280, margin: '0 auto' }} onClick={conectarBling}>
                Conectar com Bling
              </button>
              <p style={{ marginTop: 14, fontSize: 12, color: '#aaa' }}>
                Uma janela do Bling vai abrir. Após autorizar, esta tela atualiza automaticamente.
              </p>
            </div>
          )}

          {fase === 'carregando' && (
            <div className="bling-status">
              <div className="spin">⚙️</div>
              <p>Buscando produtos no Bling...</p>
            </div>
          )}

          {fase === 'erro' && (
            <div className="bling-erro">❌ {erro}</div>
          )}

          {fase === 'lista' && produtosVisiveis.length === 0 && (
            <div className="bling-status">
              {modo === 'atualizar'
                ? 'Nenhum produto local foi importado do Bling ainda.'
                : 'Nenhum produto ativo encontrado no Bling.'}
            </div>
          )}

          {fase === 'lista' && produtosVisiveis.length > 0 && (
            <>
              <div className="bling-toolbar">
                <span className="bling-count">
                  {produtosVisiveis.length} produto{produtosVisiveis.length !== 1 ? 's' : ''}
                  {modo === 'importar' && qtdJaImportados > 0 && (
                    <span style={{ color: '#22c55e', marginLeft: 8, fontSize: 12 }}>
                      ✓ {qtdJaImportados} já importado{qtdJaImportados !== 1 ? 's' : ''}
                    </span>
                  )}
                </span>
                <button className="bling-selecionar-todos" onClick={toggleTodos}>
                  {produtosVisiveis.every(p => selecionados[produtos.indexOf(p)])
                    ? 'Desmarcar todos' : 'Selecionar todos'}
                </button>
              </div>

              <div className="bling-lista">
                {produtosVisiveis.map((p) => {
                  const i = produtos.indexOf(p);
                  const jaImportado = !!blingMap[String(p._blingId)];
                  return (
                    <div
                      key={i}
                      className={`bling-item ${selecionados[i] ? 'selecionado' : ''}`}
                      onClick={() => toggleItem(i)}
                    >
                      <div className="bling-item-check">{selecionados[i] ? '✓' : ''}</div>

                      {p.imagens[0]
                        ? <img src={p.imagens[0]} alt={p.titulo} className="bling-item-foto" />
                        : <div className="bling-item-foto-vazia">📦</div>
                      }

                      <div className="bling-item-info">
                        <div className="bling-item-nome">{p.titulo}</div>
                        <div className="bling-item-meta">
                          {p.altura && p.largura && p.comprimento
                            ? `${p.altura}×${p.largura}×${p.comprimento}cm`
                            : p.peso ? `${p.peso}g` : ''}
                          {jaImportado && modo === 'importar' && (
                            <span style={{ marginLeft: 8, color: '#22c55e', fontSize: 11, fontWeight: 700 }}>
                              ✓ Importado
                            </span>
                          )}
                        </div>
                      </div>

                      {p.precoWeb && p.precoWeb !== '0' && (
                        <div className="bling-item-preco">
                          R$ {parseFloat(p.precoWeb).toFixed(2)}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Seletor de campos — só aparece no modo atualizar quando há seleção */}
              {modo === 'atualizar' && qtdSelecionados > 0 && (
                <div className="bling-campos-wrap">
                  <div className="bling-campos-label">Quais dados atualizar do Bling:</div>
                  <div className="bling-campos-grid">
                    {CAMPOS_LABELS.map(({ key, label }) => (
                      <label key={key} className="bling-campo-check">
                        <input
                          type="checkbox"
                          checked={camposAtualizar[key]}
                          onChange={e => setCamposAtualizar(prev => ({ ...prev, [key]: e.target.checked }))}
                        />
                        {label}
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {fase === 'lista' && produtosVisiveis.length > 0 && (
          <div className="bling-footer">
            {modo === 'importar' ? (
              <button
                className={`btn-importar-bling${importado ? ' ok' : ''}`}
                onClick={importar}
                disabled={qtdSelecionados === 0 || importado || importando}
              >
                {importado ? '✅ Importado!'
                  : importando ? '⏳ Importando...'
                  : `Importar ${qtdSelecionados > 0 ? qtdSelecionados + ' ' : ''}produto${qtdSelecionados !== 1 ? 's' : ''}`}
              </button>
            ) : (
              <button
                className={`btn-importar-bling${importado ? ' ok' : ''}`}
                onClick={atualizar}
                disabled={
                  qtdSelecionados === 0 || importado || importando ||
                  !Object.values(camposAtualizar).some(Boolean)
                }
              >
                {importado ? '✅ Atualizado!'
                  : importando ? '⏳ Atualizando...'
                  : `Atualizar ${qtdSelecionados > 0 ? qtdSelecionados + ' ' : ''}produto${qtdSelecionados !== 1 ? 's' : ''}`}
              </button>
            )}
            {modo === 'importar' && temMais && (
              <button className="btn-mais-bling" onClick={carregarMais} disabled={carregandoMais}>
                {carregandoMais ? '...' : '+ Carregar mais'}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default BlingImport;
